export const modalReducer = (state, { type, payload }) => {
  const isOpen = type === 'OPEN'

  return { ...state, ...payload, isOpen }
}
